import { Package } from "lucide-react";
import InventoryTable from "../components/InventoryTable";

export default function RawMaterials() {
  return (
    <InventoryTable section="raw_materials" icon={Package} title="Raw Materials" />
  );
}
